import React from 'react'
import { Button as SutraButton } from 'sutra/components/Button'

import { PaneFooterRow } from 'features/charts-v2/components/filter-popover-pane.styles'

interface FilterPopoverPaneFooterProps {
  onApply: () => void
  onClear: () => void
  applyDisabled?: boolean
  clearDisabled?: boolean
}

// Shared Clear + Apply row for every in-popover editing pane (Keywords'
// per-operator sections, Smart search, Records, Sentences). Apply is the
// only thing that writes the pane's draft to the panel — nothing commits
// until it's clicked.
export const FilterPopoverPaneFooter: React.FC<
  FilterPopoverPaneFooterProps
> = ({ onApply, onClear, applyDisabled = false, clearDisabled = false }) => {
  return (
    <PaneFooterRow>
      <SutraButton
        type="button"
        $variant="secondary"
        $size="sm"
        $height="30px"
        disabled={clearDisabled}
        onClick={onClear}
      >
        Clear
      </SutraButton>
      <SutraButton
        type="button"
        $variant="primary"
        $size="sm"
        $height="30px"
        disabled={applyDisabled}
        onClick={onApply}
      >
        Apply
      </SutraButton>
    </PaneFooterRow>
  )
}
